<h1>
  <span *ngIf="mode == detailsMode.EDIT" i18n>{{ 'system.edit' | translate }}</span>
  <span *ngIf="mode == detailsMode.ADD" i18n>{{ 'system.create' | translate }}</span>
</h1>

<form class="details-form" (ngSubmit)="onSubmit(form)" [formGroup]="form" novalidate>

  <div *ngFor="let column of builder.config.columns">
    <mat-form-field *ngIf="column.editable">
      <input matInput formControlName="{{ column.key }}" placeholder="{{ column.title }}">
    </mat-form-field>
  </div>

  <div>
    <button mat-raised-button color="primary" [disabled]="form.invalid">
      <span *ngIf="mode == detailsMode.EDIT" i18n>{{ 'system.save' | translate }}</span>
      <span *ngIf="mode == detailsMode.ADD" i18n>{{ 'system.create' | translate }}</span>
    </button>
  </div>

</form>
